import { customerActions } from './actions';
import { GridViewType } from '../../../shared/components/grid/grid-config';
import { CustomerModel } from '../customer.model';
import { CUSTOMER_BADGE_LABELS, customerBadgeLabels, customerHasBadge } from './customer-badges';
import { customerAccountLabel } from '../utils/customer-lookup';

export const customersConfig: GridViewType<CustomerModel> = {
  enableColumnFilters: true,
  columns: [
    {
      code: 'actions',
      isActionColumn: true,
      actions: customerActions
    },
    {
      // The leading column: one place to read who a row is. Wide on purpose (see
      // `.col--customer-label` in customers.component.ts). A text filter, so it matches
      // case-insensitively on either half.
      code: 'customerLabel',
      label: 'Account Number - Customer Name',
      class: 'col--customer-label',
      filterType: 'text',
      getValue: (c: CustomerModel) => customerAccountLabel(c),
    },
    {
      // Hidden by default — the leading column carries it — but kept so it can be shown again
      // from the column menu and filtered on its own. Text filter: case-insensitive substring.
      code: 'companyName',
      label: 'Customer Name',
      filterType: 'text',
      visible: false,
    },
    {
      label: 'Account Number',
      code: 'companyAccountNumber',
      filterType: 'text',
      visible: false,
    },
    {
      label: 'Last Name',
      code: 'contactLastName',
      filterType: 'select'
    },
    {
      label: 'First Name',
      code: 'contactFirstName',
      filterType: 'select'
    },
    {
      label: 'Payment Types',
      code: 'paymentTypes',
      filterType: 'select',
    },
    {
      // Generic trailing badge slot — renders every row-level marker as a chip.
      // Add a new badge by extending the `badges` template in
      // customers.component.html; this stays one column however many there are.
      label: 'Badges',
      code: 'badges',
      template: 'badges',
      sortable: false,
      // A cell holding a SET needs its own match: the default select filter
      // compares the whole cell, so a row badged "TEST INACTIVE" would never
      // match a filter of "INACTIVE".
      filterType: 'select',
      filterOptions: CUSTOMER_BADGE_LABELS,
      filterPredicate: (c: CustomerModel, label: string) => customerHasBadge(c, label),
      // Cells render from the template; this is what the CSV/PDF export sees.
      getValue: (c: CustomerModel) => customerBadgeLabels(c),
    },
  ]
};
